import { Button } from 'components/Button'
import { EventId } from '../machineTypes'
import Avatar from 'common/Avatar/Avatar'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import Styles from './InviteEmails.module.scss'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Modal } from 'almanac-ui/Modal'

interface Props {
  newEmails: string[]
}

export const InviteEmails = ({ newEmails }: Props) => {
  const { service, isLoading } = useReviewsWizard()
  const workspace = useCurrentWorkspace()
  const canInviteToWorkspace = !workspace?.guest

  return (
    <>
      <Modal.Top>
        <Modal.BackButton aria-label="Back" onPress={() => service.send(EventId.BACK)} />
      </Modal.Top>
      <Modal.Header title="Invite collaborators outside of your workspace" />
      <Modal.Content>
        <div className={Styles.bodyText}>
          These people are not a part of your workspace.{' '}
          {canInviteToWorkspace && 'Would you like to add them to the workspace?'} Guests can edit the document and make
          changes.
        </div>
        <ul className={Styles.emails}>
          {newEmails.map((email) => (
            <li key={email} className={Styles.email}>
              <Avatar url={null} label={email[0]} size={32} randomColor />
              <div>{email}</div>
            </li>
          ))}
        </ul>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          {canInviteToWorkspace && (
            <Button
              variant="secondary"
              size="xl"
              onPress={() => service.send(EventId.INVITE_GUESTS)}
              isDisabled={isLoading}
            >
              Invite as Guests to this Review
            </Button>
          )}
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button
            onPress={() => service.send(canInviteToWorkspace ? EventId.INVITE_TO_WORKSPACE : EventId.INVITE_GUESTS)}
            data-heap-id="submit-feedback-request"
            isDisabled={isLoading}
            size="xl"
          >
            {canInviteToWorkspace ? 'Invite to Workspace' : 'Invite as Guests to this Review'}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
